import { mutationTypes } from '@/core/constants'
import { mapMutations } from 'vuex'

export default {
	methods: {
		desabilitarLoadingGlobal() {
			this.disableGlobalLoading()
		},
		habilitarLoadingGlobal() {
			this.enableGlobalLoading()
		},
		ativarCarregamentoManual() {
			this.$store.commit(mutationTypes.COMUM.SET_LOADING_MANUAL, true)
		},
		desativarCarregamentoManual() {
			this.$store.commit(mutationTypes.COMUM.SET_LOADING_MANUAL, false)
		},
		setMensagemLoading(mensagem) {
			this.setLoadingMessage(mensagem)
		},
		async executarSemLoading(fn) {
			this.$store.commit(mutationTypes.COMUM.SET_EXECUTAR_SEM_LOADING, true)
			try {
				return await fn()
			} finally {
				this.$store.commit(mutationTypes.COMUM.SET_EXECUTAR_SEM_LOADING, false)
			}
		},
		...mapMutations([
			mutationTypes.LOKI.DISABLE_GLOBAL_LOADING,
			mutationTypes.LOKI.ENABLE_GLOBAL_LOADING,
			mutationTypes.LOKI.SET_LOADING_MESSAGE,
		]),
	},
}
